module.exports = __webpack_public_path__ + "img/image19.6215fd0f.jpg";